import Vue from 'vue'
// LANDING PAGE COMPONENT
import CardGrey from '@/components/landing-page/CardGrey'
import FastestSolution from '@/components/landing-page/FastestSolution'
import Doctor from '@/components/landing-page/Doctor'
import HospitalClinic from '@/components/landing-page/HospitalClinic'
import Psycholog from '@/components/landing-page/Psychologist'
import Feature from '@/components/landing-page/Feature'
import Questions from '@/components/landing-page/Questions'
import Price from '@/components/landing-page/Price'
import Testimonial from '@/components/landing-page/Testimonial'
import ContactUs from '@/components/landing-page/ContactUs'
import DownloadApp from '@/components/landing-page/DownloadApp'

// YESDOK COMPONENT
import CardWithNumber from '@/components/CardWithNumber'
import YesModal from '@/components/YesModal'
import YesButton from '@/components/YesButton'
import YesInput from '@/components/YesInput'
import YesNavbarClassic from '@/components/YesNavbarClassic'
import YesAlert from '@/components/YesAlert'
import YesTooltip from '@/components/YesTooltip'
import HelpComponent from '@/components/Help'

// LANDING PAGE COMPONENT
Vue.component('CardGrey', CardGrey)
Vue.component('FastestSolution', FastestSolution)
Vue.component('Doctor', Doctor)
Vue.component('HospitalClinic', HospitalClinic)
Vue.component('Psycholog', Psycholog)
Vue.component('Feature', Feature)
Vue.component('Price', Price)
Vue.component('Questions', Questions)
Vue.component('Testimonial', Testimonial)
Vue.component('DownloadApp', DownloadApp)
Vue.component('ContactUs', ContactUs)

// YESDOK COMPONENT
Vue.component('CardWithNumber', CardWithNumber)
Vue.component('YesModal', YesModal)
Vue.component('YesButton', YesButton)
Vue.component('YesInput', YesInput)
Vue.component('YesNavbarClassic', YesNavbarClassic)
Vue.component('YesAlert', YesAlert)
Vue.component('YesTooltip', YesTooltip)
Vue.component('YesHelp', HelpComponent)
